import { ReactNode } from "react";
import { MinimalPageContainer } from "../../components/layouts";
import { LinkButton } from "cy-fe";
import { CircleAlertIcon } from "lucide-react";

export interface IdentificationUnavailableErrorProps {
  /** The app's logo component to display in the header */
  logo: ReactNode;
  /** URL to navigate back to (defaults to /complete-registration) */
  backUrl?: string;
}

/**
 * Error state displayed when no identification types are available.
 * Provides a user-friendly message and a way to navigate back.
 */
export function IdentificationUnavailableError({
  logo,
  backUrl = "/complete-registration",
}: IdentificationUnavailableErrorProps) {
  return (
    <MinimalPageContainer headerChildren={logo}>
      <div className="flex flex-col items-center justify-center px-4 py-12">
        <CircleAlertIcon className="text-error-500 h-16 w-16" />
        <h1 className="mt-6 text-xl font-semibold">
          Unable to load identification options
        </h1>
        <p className="mt-2 text-center text-gray-600">
          We couldn&apos;t load the identification options at this time. Please
          try again later or contact support if the problem persists.
        </p>
        <LinkButton
          href={backUrl}
          vSize="lg"
          vColor="secondary"
          className="mt-8"
        >
          Go back
        </LinkButton>
      </div>
    </MinimalPageContainer>
  );
}
